module.exports = __webpack_public_path__ + "img/timeline_miscevent-7.aba14d06.jpg";